import React, { useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Slideshow from "../SlideShow/SlideShow";
import AOS from "aos";
import "aos/dist/aos.css";
const useStyles = makeStyles((theme) => ({
  bg: {
    color: "white",
    padding: "5rem",
    marginTop: "10rem",
  },
}));

export default function Team() {
  const classes = useStyles();
  useEffect(() => {
    AOS.init({});
  }, []);
  return (
    <div className={classes.bg}>
      <Typography variant="h3" gutterBottom style={{ fontWeight: 300 }} data-aos="fade-right" data-aos-duration="1000">
        Đội ngũ
      </Typography>
      <Slideshow />
    </div>
  );
}
